import {useTimeUnitTranslation, useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled from 'styled-components';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {useCountdown} from '../Countdown/useCountdown';

interface CampaignBarProps {
  style?: React.CSSProperties;
  endsAt: Date;
  backgroundColor: string;
  textColor: string;
}

export const CampaignBar: React.FC<CampaignBarProps> = ({
  style,
  endsAt,
  backgroundColor,
  textColor,
}) => {
  const {t} = useTranslation();
  const countdown = useCountdownString(endsAt);

  return (
    <Container
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      style={style}
    >
      {t('Only {countdown} left until the EXTRA Sale ends', {countdown})}
    </Container>
  );
};

const Container = styled.div<{$backgroundColor: string; $textColor: string}>`
  width: 100%;
  padding: 2px 0;
  background-color: ${({$backgroundColor}) => $backgroundColor};
  color: ${({$textColor}) => $textColor};
  text-align: center;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.bold};
  line-height: ${FONT_SIZES.px18};
`;

const useCountdownString = (endsAt: Date): string => {
  const [days, hours, minutes, seconds] = useCountdown(endsAt);
  const timeFormat = useTimeUnitTranslation('shorter');

  return `${days !== '00' ? `${days}${timeFormat.days} ` : ''}${hours}${
    timeFormat.hours
  } ${minutes}${timeFormat.minutes} ${seconds}${timeFormat.seconds}`;
};
